import classNames from 'classnames';
import * as React from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Heading, Icon, Text, getIcon } from '@quality24/design-system';

import {
  HeadingComponentData,
  TextComponentData,
  TextViewData,
} from '../../@types';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  data: TextViewData;
}

/**
 * <TextViewContainer> page
 */
export const TextViewContainer: React.FunctionComponent<Props> = ({
  className,
  data: { className: configClassName, components },
  ...htmlElementProps
}) => (
  <div className={classNames(className, configClassName)} {...htmlElementProps}>
    {components.map(({ type, ...config }, idx) => {
      // Here the array order does not change so we
      // can safely disable the eslint-warning
      const id = `${type}-${config.id}-${idx}`;

      if (type === 'heading') {
        return (
          <Heading
            key={id}
            as={(config.as as HeadingComponentData['as']) || 'h3'}
            className={config.className}
            size={config.size || 'lg1'}
            weight={config.weight || 'bold'}
            color={config.color || 'black'}
          >
            {config.icon && (
              <Icon icon={getIcon(config.icon) || faTimes} className="mr-2" />
            )}
            {config.value}
          </Heading>
        );
      }
      if (type === 'text') {
        return (
          <Text
            key={id}
            as={config.as as TextComponentData['as']}
            className={config.className}
            size={config.size || 'md'}
            weight={config.weight || 'regular'}
            color={config.color || 'blackLight'}
          >
            {config.icon && (
              <Icon icon={getIcon(config.icon) || faTimes} className="mr-2" />
            )}
            {config.value}
          </Text>
        );
      }
      return null;
    })}
  </div>
);

export default TextViewContainer;
